import { Space, Typography } from 'antd';
import styles from './loading.page.module.scss';

interface LoadingPageProps {
  text: string;
}

export default function LoadingPage(props: LoadingPageProps) {
  return (
    <div className={styles['container']}>
      <Space direction="vertical">
        <Typography.Title className={styles['title']}>
          {props.text}
        </Typography.Title>
      </Space>
    </div>
  );
}
